<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          class="box"
          ref="productForm"
          :model="product"
          label-width="70px"
        >
          <fieldset class="mgb15" v-if="showBaseInfoDF">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.productNo')">{{
                  product.productNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.category')">{{
                  product.categoryName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.unit')">{{
                  product.unit
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.brand')">{{
                  product.brand
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.purchaseUrl')"
                  :prop="'purchaseUrl'"
                >
                  <a
                    v-if="
                      product.purchaseUrl != null &&
                      product.purchaseUrl.trim() != ''
                    "
                    :href="product.purchaseUrl"
                    target="_blank"
                    >链接</a
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>
              {{ $t("product.material") }}
              <i
                v-if="Permit.canActionsChargeEdition('mmsProductIngredient')"
                class="el-icon-circle-plus green mgr10"
                @click="addIngredient"
              />

              <i
                v-if="Permit.canActionsChargeEdition('mmsProductIngredient')"
                class="el-icon-circle-plus green"
                @click="addIngredientAndMaterial"
                >无</i
              >
              <el-select
                v-model="productNo"
                filterable
                clearable
                remote
                :placeholder="$t('prompt.searchProductNoToAddMaterials')"
                size="mini"
                style="width: 270px"
                class="mgl5"
                :remote-method="querySearchProductNo"
                :loading="productsLoading"
                @change="handleSelectProductNo"
              >
                <el-option
                  v-for="p in products"
                  :key="p.productNo"
                  :label="p.productNo"
                  :value="p.productNo"
                />
              </el-select>
              <small
                v-if="Permit.canActionsChargeEdition('globalCostPrice')"
                class="orange mgl5"
              >
                {{ $t("material.baseCost") }}:{{ mmsCost | currency4 }},
              </small>
              <small class="orange">{{ boms.length }} 种配料</small>
              <el-dropdown
                v-if="groupBoms.length != 0"
                class="float-right"
                @command="downloadBoms"
              >
                <el-button type="default" size="mini">
                  {{ $t("action.download") }}
                  <i class="el-icon-caret-bottom el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="download1">
                    <div class="font10">{{ $t("action.download") }}</div>
                  </el-dropdown-item>
                  <el-dropdown-item command="download2">
                    <div class="font10">{{ $t("action.download") }}(简版)</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button
                class="float-right mgr10"
                v-if="boms.length != 0"
                type="default"
                size="mini"
                @click="printPriductMaterial('printPriductMaterialDiv')"
                >{{ $t("action.printPriductMaterial") }}</el-button
              >
            </legend>
            <vxe-table
              :loading="loadingMaterial"
              :data="groupBoms"
              :span-method="mergeMethod"
              id="bomsTable"
              row-id="id"
              ref="groupBomsTable"
              class="recordsTable"
              :row-class-name="calculateBgColor"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              border
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="sequence"
                :title="$t('text.sequence')"
                width="50"
              >
                <template v-slot="{ row }">
                  <span v-if="!row.isSubject">
                    {{ row.sequence }}
                  </span>
                  <div v-else class="">
                    {{ row.subject }}
                    <span class="font10"
                      >({{ row.subjectTotal | currency4 }})</span
                    >
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="materialSerialNo"
                :title="$t('material.serialNo')"
                width="100"
              >
                <template v-slot="{ row }">
                  <el-popover
                    placement="right"
                    width="600"
                    trigger="click"
                    @show="getMaterialSuppliers(row)"
                  >
                    <vxe-table
                      :data="materialSuppliers"
                      id="materialSuppliersTable"
                      row-id="id"
                      class="recordsTable"
                      size="mini"
                      resizable
                      round
                      auto-resize
                      border
                      highlight-hover-row
                    >
                      <vxe-table-column
                        field="supplierName"
                        :title="$t('menu.suppliers')"
                        min-width="200"
                      />

                      <vxe-table-column
                        field="supplierMaterialNo"
                        :title="$t('material.supplierSerialNo')"
                        min-width="200"
                      />
                      <vxe-table-column
                        field="price"
                        :title="$t('product.supplierPrice')"
                        min-width="90"
                      >
                        <template v-slot="{ row }">
                          <span v-if="row.price != null">
                            {{ row.price | currency4 }}
                          </span>
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="defaultSupplier"
                        :title="$t('product.defaultSupplier')"
                        min-width="90"
                      >
                        <template v-slot="{ row }">{{
                          $t("boolean." + row.defaultSupplier)
                        }}</template>
                      </vxe-table-column>
                    </vxe-table>
                    <span slot="reference" class="blue popover-reference">
                      {{ row.material.serialNo }}
                    </span>
                  </el-popover>
                </template>
              </vxe-table-column>
              <vxe-table-column field="name" :title="$t('material.name')">
                <template v-slot="{ row }">
                  <span v-if="row.material">{{ row.material.name }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="baseQuantity"
                :title="$t('material.quantity')"
              >
                <template v-slot="{ row }">
                  {{ row.baseQuantity }}
                  <span v-if="row.material">{{ row.material.unit }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column field="color" :title="$t('material.color')">
                <template v-slot="{ row }">
                  <span v-if="row.material"
                    >{{ row.material.color }}({{ row.material.colorNo }})</span
                  >
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActionsChargeEdition('globalCostPrice')"
                field="price"
                :title="$t('material.outPrice')"
              >
                <template v-slot="{ row }">
                  <span v-if="row.material && row.material.price">{{
                    row.material.price | currency4
                  }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActionsChargeEdition('globalCostPrice')"
                field="material"
                :title="$t('material.subtotal')"
              >
                <template v-slot="{ row }">
                  <span v-if="row.material && row.material.price">{{
                    (row.material.price * row.baseQuantity) | currency4
                  }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="sizeQuantities"
                :title="$t('material.sizeQuantity')"
              >
                <template v-slot="{ row }">
                  <div
                    v-for="(
                      sizeQuantity, sizeQuantityIdx
                    ) of row.sizeQuantities"
                    :key="sizeQuantityIdx"
                    class="font10"
                  >
                    {{ sizeQuantity.size }}：{{ sizeQuantity.quantity }}
                    <span v-if="row.material">{{ row.material.unit }}</span>
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column field="remark" :title="$t('text.remark')">
                <template v-slot="{ row }">
                  <raw-html-limit-number :content="row.remark" :number="6" />
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActionsChargeEdition('mmsProductIngredient')"
                field="action"
                :title="$t('text.action')"
                width="90"
              >
                <template v-slot="{ row }">
                  <span v-if="!row.isSubject">
                    <el-button type="text" size="mini" @click="editBom(row)">{{
                      $t("text.edit")
                    }}</el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteBom(row)"
                      >{{ $t("text.delete") }}</el-button
                    >
                  </span>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
          <fieldset class="mgb15">
            <legend>
              {{ $t("product.variantMap") }}
              <i
                v-if="
                  Permit.canActionsChargeEdition('mmsProductIngredient') &&
                  boms.length != 0
                "
                class="el-icon-circle-plus green"
                @click="addVariantMap"
              />
              <el-button
                v-if="
                  Permit.canActionsChargeEdition('mmsProductIngredient') &&
                  boms.length != 0
                "
                type="default"
                size="mini"
                class="mgl5"
                @click="importVariantMap"
                >{{ $t("action.importVariantMap") }}</el-button
              >
              <el-button
                v-if="groupVariantMaps.length != 0"
                type="default"
                size="mini"
                class="float-right"
                @click="downloadVariantMap"
                >{{ $t("action.download") }}</el-button
              >
            </legend>
            <div v-if="importVariantMapDF" class="pd10 mgb20">
              <div class="import">
                <ul class="orange">
                  <li class="explain">
                    {{ $t("newImportVariantMap.excelTitle") }}
                  </li>
                  <li class="explain">
                    {{ $t("newImport.excelTemplate") }}:
                    <a :href="excelTemplate" target="_blank">{{
                      $t("newImport.clickDownload")
                    }}</a>
                  </li>
                  <li class="explain">
                    {{ $t("newImport.beCareful") }}：1、{{
                      $t("newImport.beCarefulMustFill")
                    }}
                  </li>
                  <li class="beCareful">
                    2、{{ $t("newImportVariantMap.beCarefulColor") }}
                  </li>
                  <li class="beCareful">
                    3、{{ $t("newImportVariantMap.beCarefulMaterial") }}
                  </li>
                </ul>
              </div>
              <div>
                <el-upload
                  ref="upload"
                  :action="url"
                  :headers="fileHeaders"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :on-success="importResult"
                  accept=".xls, .xlsx"
                  class="center"
                >
                  <el-button
                    type="success"
                    size="mini"
                    :loading="importLoading"
                    >{{ $t("action.import") }}</el-button
                  >
                </el-upload>
              </div>
              <div v-if="importResults.length != 0">
                <div style="margin-left: 15px">
                  {{ $t("newImport.results") }}：
                </div>
                <div class="import">
                  <ol>
                    <li
                      v-for="(r, index) of importResults"
                      :key="index"
                      class="explain"
                    >
                      <span v-if="r.type == 'fail'" class="grey">{{
                        r.message
                      }}</span>
                      <span v-if="r.type == 'success'" class="green">{{
                        r.message
                      }}</span>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <el-row v-if="variantMaps.length != 0" :gutter="20">
              <el-col
                v-for="(gvm, index) of groupVariantMaps"
                :key="index"
                :span="12"
              >
                <fieldset>
                  <legend style="border-bottom: 1px solid #d9d9d9">
                    {{ gvm.color }}

                    <i
                      v-if="
                        Permit.canActionsChargeEdition('mmsProductIngredient')
                      "
                      class="el-icon-circle-plus green"
                      @click="addVariantMapsByColor(gvm)"
                    />

                    <span
                      v-if="
                        Permit.canActionsChargeEdition('mmsProductIngredient')
                      "
                      class="red float-right"
                      @click="deleteVariantMapsByColor(gvm.data)"
                      >{{ $t("text.delete") }}</span
                    >
                  </legend>
                  <fieldset
                    v-for="(d, dIdx) of gvm.data"
                    :key="dIdx"
                    class="mgb10"
                  >
                    <legend>
                      <el-row>
                        <el-col :span="10">
                          {{ d.materialSerialNo }}
                          <span class="font10"
                            >({{ d.materialName }}) {{ d.materialColor }}</span
                          >
                        </el-col>
                        <el-col :span="2">-></el-col>
                        <el-col :span="10">
                          {{ d.replaceMaterialSerialNo }}
                          <span
                            v-if="d.replaceMaterialName != null"
                            class="font10"
                            >({{ d.replaceMaterialName }})
                            {{ d.replaceMaterialColor }}</span
                          >
                        </el-col>
                        <el-col :span="2">
                          <i
                            v-if="
                              Permit.canActionsChargeEdition(
                                'mmsProductIngredient'
                              )
                            "
                            class="el-icon-edit blue"
                            @click="editVariantMap(d, gvm.data)"
                          />
                          <i
                            v-if="
                              Permit.canActionsChargeEdition(
                                'mmsProductIngredient'
                              )
                            "
                            class="el-icon-delete red"
                            @click="deleteVariantMap(d)"
                          />
                        </el-col>
                      </el-row>
                    </legend>
                  </fieldset>
                </fieldset>
              </el-col>
            </el-row>
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="
          boms.length != 0 &&
          Permit.canActionsChargeEdition('mmsProductIngredient')
        "
        type="primary"
        size="small"
        @click="ingredientFinish"
        >{{ $t("action.ingredientFinish") }}</el-button
      >
    </div>
    <!-- 编辑-->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('product.material')])"
      :visible.sync="editIngredientDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="editIngredientObjForm"
        :model="editIngredientObj"
        label-width="70px"
      >
        <el-form-item
          :label="$t('material.baseQuantity')"
          :prop="'baseQuantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('material.baseQuantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editIngredientObj.baseQuantity"
          />
        </el-form-item>

        <div v-if="editIngredientObj.sizeQuantities.length != 0">
          <el-form-item
            :prop="'sizeQuantities'"
            :label="$t('material.sizeQuantity')"
          >
            <el-row>
              <el-col
                v-for="(
                  sizeQuantity, index
                ) in editIngredientObj.sizeQuantities"
                :key="index"
                :span="12"
              >
                <el-input size="small" v-model.trim="sizeQuantity.quantity">
                  <template slot="prepend">
                    <div>
                      <raw-html-limit-number
                        :content="sizeQuantity.size"
                        :number="6"
                      />
                    </div>
                  </template>
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </div>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="editIngredientObj.remark"
            type="textarea"
            :rows="2"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editIngredientSubmitDoing"
          size="small"
          @click="editIngredientSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editIngredientDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.material')])"
      :close-on-click-modal="false"
      :visible.sync="addIngredientDF"
      width="60%"
    >
      <el-form ref="addIngredientObjForm" :model="addIngredientObj">
        <div v-for="(item, index) in addIngredientObj.items" :key="index">
          <el-row :gutter="5">
            <el-col :span="9">
              <el-form-item>
                <el-select
                  size="small"
                  v-model="item.materialId"
                  filterable
                  clearable
                  remote
                  :placeholder="$t('material.serialNoName')"
                  :remote-method="querySearchMaterial"
                  :loading="materialLoading"
                  @change="handleSelectMaterial(index)"
                >
                  <el-option
                    v-for="material in materials"
                    :key="material.id"
                    :label="material.serialNoName"
                    :value="material.id"
                    :style="
                      material.suppliersNoStr == ''
                        ? ''
                        : 'height: 55px !important'
                    "
                  >
                    <div>
                      <div>
                        {{ material.serialNoName }}
                        <span
                          v-if="material.parentMaterialId != null"
                          class="font8 orange"
                        >
                          (子物料)
                        </span>
                      </div>
                      <div class="suppliersNoStr">
                        {{ material.suppliersNoStr }}
                      </div>
                    </div>
                  </el-option>
                </el-select>
                <span v-if="item._localRepeat || item._invExist" :span="4">
                  <!-- <el-form-item> -->
                  <small v-if="item._localRepeat" class="red">{{
                    $t("rules.filledIn", [$t("product.material")])
                  }}</small>
                  <small v-if="item._invExist" class="red">{{
                    $t("rules.mixed", [$t("product.material")])
                  }}</small>
                  <!-- </el-form-item> -->
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-input
                  v-if="item.materialId == null"
                  size="small"
                  v-model.trim="item.name"
                  :placeholder="$t('product.materialInfo')"
                />
                <span v-else
                  >{{ item._subjectName }}/{{ item._color }}
                  <span class="mgl5 font8">({{ item._unit }})</span>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.baseQuantity"
                  :placeholder="
                    $t('rules.mustFillSimple', [$t('material.baseQuantity')])
                  "
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.remark"
                  :placeholder="$t('text.remark')"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="!item._sizesQuantityDF" :span="2">
              <el-form-item>
                <small class="blue" @click="showSizesQuantity(index)">{{
                  $t("product.sizeQty")
                }}</small>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="removeIngredient(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="item._sizesQuantityDF" class="mgb15">
            <el-row v-if="item._sizeQuantities.length !== 0" :gutter="10">
              <el-col
                v-for="sizeQuantity in item._sizeQuantities"
                :key="sizeQuantity.size"
                :span="6"
                class="mb10"
              >
                <el-input
                  size="small"
                  v-model.trim="sizeQuantity.quantity"
                  :placeholder="item._unit"
                >
                  <template slot="prepend">
                    <div>
                      <raw-html-limit-number
                        :content="sizeQuantity.size"
                        :number="6"
                      />
                    </div>
                  </template>
                </el-input>
              </el-col>
              <el-col :span="24">
                <small v-if="item._sizeQuantities.length == 0" class="orange">{{
                  $t("prompt.noProductSize")
                }}</small>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="center">
          <el-button
            v-if="addIngredientObj.items.length < 10"
            type="info"
            @click="addMore"
            plain
            round
            >{{ $t("action.addMore") }}</el-button
          >
          <span v-else class="orange">
            {{ $t("prompt.addMorePrompt") }}
          </span>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addIngredientSubmitDoing"
          size="small"
          @click="addIngredientSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addIngredientDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增换料映射 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.variantMap')])"
      :close-on-click-modal="false"
      :visible.sync="addVariantMapDF"
      width="50%"
    >
      <el-form ref="addVariantMapObjForm" :model="addVariantMapObj">
        <fieldset v-if="addVariantMapsType == 'whole'">
          <legend>
            {{ $t("material.color") }}
            <el-checkbox
              v-model="checkAllColors"
              :indeterminate="isIndeterminateColors"
              @change="handleCheckAllColorsChange"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
          </legend>
          <el-form-item
            :prop="'selectedColors'"
            :rules="[
              {
                required: true,
                message: $t('rules.select', [$t('material.color')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-checkbox-group
              size="small"
              v-model="addVariantMapObj.selectedColors"
              @change="handleCheckedColorsChange"
            >
              <el-checkbox
                v-for="color in addVariantMapColors"
                :key="color"
                :label="color"
                >{{ color }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("prompt.needMapMaterial") }}</legend>
          <el-row
            v-for="(material, index) in addVariantMapObj.needMapMaterials"
            :key="index"
            :gutter="5"
            class="mgb10"
          >
            <el-col :span="23">
              <el-select
                size="small"
                v-model="material.bomId"
                :placeholder="$t('product.material')"
                @change="selectNeedMapMaterial(index)"
                filterable
                clearable
              >
                <el-option
                  v-for="bom in validBoms"
                  :key="bom.id"
                  :label="bom.serialNoName"
                  :value="bom.id"
                />
              </el-select>
            </el-col>
            <el-col :span="1">
              <i
                v-if="index"
                class="el-icon-delete red"
                @click="removeNeedMapMaterial(index)"
              />
            </el-col>
          </el-row>
          <el-button
            type="success"
            size="mini"
            plain
            @click="addMoreNeedMapMaterial"
            >+ {{ $t("product.variantMapSimple") }}</el-button
          >
        </fieldset>
        <fieldset v-if="addVariantMapObj.variantMaps.length != 0" class="mgb10">
          <legend>{{ $t("product.variantMap") }}</legend>
          <el-row :gutter="20">
            <el-col
              v-for="(vm, index) of addVariantMapObj.variantMaps"
              :key="index"
              :span="12"
            >
              <fieldset class="mgb15">
                <legend style="border-bottom: 1px solid #d9d9d9">
                  {{ vm.color }}
                </legend>
                <div
                  v-for="(d, itemIndex) of vm.data"
                  :key="itemIndex"
                  class="mgb10"
                >
                  <el-row :gutter="5">
                    <el-col :span="10">
                      {{ d._material.serialNo }}
                      <small>{{ d._material.color }}</small>
                    </el-col>
                    <el-col :span="3">---></el-col>
                    <el-col :span="11">
                      <el-select
                        v-model="d.replaceMaterialId"
                        filterable
                        remote
                        :placeholder="$t('prompt.replace')"
                        size="mini"
                        :remote-method="querySearchAddVariantMap"
                        :loading="querySearchAddVariantMapLoading"
                        @change="handleSelectAddVariantMap(itemIndex, index)"
                      >
                        <el-option
                          v-for="material in materials"
                          :key="material.id"
                          :label="material.serialNoName"
                          :value="material.id"
                          :style="
                            material.suppliersNoStr == ''
                              ? ''
                              : 'height: 55px !important'
                          "
                        >
                          <div v-if="material.parentMaterialId == null">
                            <div>
                              <div>
                                {{ material.serialNoName }}
                                <span
                                  v-if="material.parentMaterialId != null"
                                  class="font8 orange"
                                >
                                  (子物料)
                                </span>
                              </div>
                              <div class="suppliersNoStr">
                                {{ material.suppliersNoStr }}
                              </div>
                            </div>
                          </div>
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
              </fieldset>
            </el-col>
          </el-row>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addVariantMapSubmitDoing"
          size="small"
          @click="addVariantMapSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addVariantMapDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <div id="printPriductMaterialDiv" style="display: none">
      <div style="text-align: center">
        <strong>{{ product.productNo }} 的配料表</strong>
      </div>
      <div style="font-size: 14px">
        {{ boms.length }} 种配料 {{ $t("material.baseCost") }}:{{
          mmsCost | currency4
        }}
      </div>
      <div style="width: 100%">
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: left;
            margin-bottom: 20px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <thead>
            <tr
              style="
                border: 1px solid #dfe5ec;
                text-align: center;
                height: 30px;
              "
            >
              <td style="border: 1px solid #dfe5ec">
                <strong>{{ $t("material.serialNo") }}</strong>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <strong>{{ $t("material.name") }}</strong>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <strong>{{ $t("material.color") }}</strong>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <strong>{{ $t("material.quantity") }}</strong>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <strong>{{ $t("material.sizeQuantity") }}</strong>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <strong>{{ $t("material.price") }}</strong>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <strong>{{ $t("material.subtotal") }}</strong>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <strong>{{ $t("text.remark") }}</strong>
              </td>
            </tr>
          </thead>
          <tbody
            v-for="(group, index) of groupBoms"
            :key="index"
            style="text-align: center"
          >
            <tr
              v-if="group.isSubject"
              style="background-color: #eff8ff; height: 24px"
            >
              <td
                colspan="9"
                style="border: 1px solid #dfe5ec; text-align: left"
              >
                <strong>{{ group.subject }}</strong>
                &nbsp;&nbsp;
                {{ $t("text.total") }}:{{ group.subjectTotal | currency4 }}
              </td>
            </tr>
            <tr v-else>
              <td style="border: 1px solid #dfe5ec; width: 100px">
                {{ group.material.serialNo }}
              </td>
              <td style="border: 1px solid #dfe5ec; width: 100px">
                {{ group.material.name }}
              </td>
              <td style="border: 1px solid #dfe5ec; width: 100px">
                {{ group.material.color }}
                <small>({{ group.material.colorNo }})</small>
              </td>

              <td style="border: 1px solid #dfe5ec; width: 60px">
                {{ group.baseQuantity }}{{ group.material.unit }}
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                <div
                  v-for="(sq, sqIndex) of group.material.sizeQuantities"
                  :key="sqIndex"
                >
                  <small
                    >{{ sq.size }}:{{ sq.quantity
                    }}{{ group.material.unit }}</small
                  >
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                {{ group.material.price | currency4 }}
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                {{ (group.baseQuantity * group.material.price) | currency4 }}
              </td>
              <td style="border: 1px solid #dfe5ec; text-align: left">
                {{ group.remark }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 编辑换料映射 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editVariantMapDF"
      width="30%"
    >
      <el-form
        ref="editVariantMapObjForm"
        :model="editVariantMapObj"
        label-width="60px"
      >
        <el-form-item
          :label="$t('material.serialNo')"
          :prop="'replaceMaterialId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('material.serialNo')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="editVariantMapObj.replaceMaterialId"
            filterable
            remote
            :clearable="true"
            :placeholder="$t('material.serialNoName')"
            :remote-method="querySearchSerialNo"
            :loading="serialNosLoading"
            @change="handleSelectSerialNoEditVariantMap"
          >
            <el-option
              v-for="material in materials"
              :key="material.id"
              :label="material.text"
              :value="material.id"
              :style="
                material.suppliersNoStr == '' ? '' : 'height: 55px !important'
              "
            >
              <div>
                <div>
                  {{ material.text }}
                  <span
                    v-if="material.parentMaterialId != null"
                    class="font8 orange"
                  >
                    (子物料)
                  </span>
                </div>
                <div class="suppliersNoStr">
                  {{ material.suppliersNoStr }}
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editVariantMapDoing"
          size="small"
          @click="editVariantMapSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editVariantMapDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!--  新增2-->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.material')])"
      :visible.sync="addIngredientAndMaterialDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form
        ref="addIngredientAndMaterialObjForm"
        :model="addIngredientAndMaterialObj"
        label-width="90px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.serialNo')"
              :prop="'serialNo'"
              :rules="[
                {
                  required: true,
                  validator: validateSerialNo,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="addIngredientAndMaterialObj.serialNo"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.name')"
              :prop="'name'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.name')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addIngredientAndMaterialObj.name"
                style="width: 100%"
                :fetch-suggestions="querySearchNames"
                @select="handleSelectNames"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.subject')"
              :prop="'subjectId'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.subject')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                size="small"
                v-model.trim="addIngredientAndMaterialObj.subjectId"
                style="width: 100%"
              >
                <el-option
                  v-for="subject in subjects"
                  :key="subject.id"
                  :label="subject.name"
                  :value="subject.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.inUnit')"
              :prop="'inUnit'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.inUnit')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addIngredientAndMaterialObj.inUnit"
                style="width: 100%"
                :fetch-suggestions="querySearchInUnits"
                @select="handleSelectInUnits"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.outUnit')"
              :prop="'unit'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.outUnit')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addIngredientAndMaterialObj.unit"
                style="width: 100%"
                :fetch-suggestions="querySearchUnits"
                @select="handleSelectUnits"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.exchange')"
              :prop="'exchange'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.exchange')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="addIngredientAndMaterialObj.exchange"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.color')"
              :prop="'unit'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.color')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addIngredientAndMaterialObj.color"
                style="width: 100%"
                :fetch-suggestions="querySearchColors"
                @select="handleSelectColors"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.colorNo')"
              :prop="'unit'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.colorNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="addIngredientAndMaterialObj.colorNo"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.baseQuantity')"
              :prop="'baseQuantity'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.baseQuantity')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="addIngredientAndMaterialObj.baseQuantity"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('text.remark')" :prop="'remark'">
              <el-input
                size="small"
                v-model.trim="addIngredientAndMaterialObj.remark"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <small
          v-if="addIngredientAndMaterialObj.sizeQuantities.length != 0"
          class="blue"
          @click="showSizesQuantityAddIngredientAndMaterial"
        >
          {{ $t("product.sizeQty") }}
        </small>
        <div
          v-if="
            addIngredientAndMaterialObj.sizeQuantities.length != 0 &&
            addIngredientAndMaterialObj._sizesQuantityDF
          "
        >
          <el-form-item
            :prop="'sizeQuantities'"
            :label="$t('material.sizeQuantity')"
          >
            <el-row>
              <el-col
                v-for="(
                  sizeQuantity, index
                ) in addIngredientAndMaterialObj.sizeQuantities"
                :key="index"
                :span="12"
              >
                <el-input size="small" v-model.trim="sizeQuantity.quantity">
                  <template slot="prepend">
                    <div>
                      <raw-html-limit-number
                        :content="sizeQuantity.size"
                        :number="6"
                      />
                    </div>
                  </template>
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addIngredientAndMaterialDoing"
          size="small"
          @click="addIngredientAndMaterialSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addIngredientAndMaterialDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Cookies from "@/utils/cookies.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Product from "@/api/product.js";
import Material from "@/api/material.js";
import Bom from "@/api/bom.js";
import { coreMmsEndpoint, fileserverEndpoint } from "@/settings";
import Color from "@/api/color.js";
import SubjectMms from "@/api/subjectMms.js";

function bulidIngredient() {
  return {
    productId: null,
    materialId: null,
    baseQuantity: null,
    sizeQuantities: [],
    remark: null,
    _sizeQuantities: [],
    _serialNo: null,
    _name: null,
    _subjectName: null,
    _color: null,
    _unit: null,

    _sizesQuantityRate: null,
    _sizesQuantityDF: false,
    _localRepeat: false,
    _invExist: false,
  };
}

function bulidVariantMap() {
  return {
    bomId: null,
    color: null,
    materialId: null,
    replaceMaterialId: null,
    _material: null,
  };
}

export default {
  props: {
    uuid: String,
    showBaseInfoDF: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [page],
  components: { RawHtmlLimitNumber },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(self.$t("rules.required", [this.$t("material.serialNo")]))
        );
        return;
      }

      Material.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("material.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      product: { uuid: null },
      boms: [],
      groupBoms: [],
      mmsCost: null,
      variantMaps: [],
      groupVariantMaps: [],
      // 编辑物料
      editIngredientDF: false,
      editIngredientObj: {
        bomId: null,
        baseQuantity: null,
        sizeQuantities: [],
        remark: null,
      },
      row: null,
      editIngredientSubmitDoing: false,
      // 新增
      addIngredientDF: false,
      addIngredientObj: {
        items: [],
      },
      addIngredientSubmitDoing: false,
      materials: [],
      materialLoading: false,
      //
      productNo: null,
      products: [],
      productsLoading: false,
      //
      importVariantMapDF: false,
      excelTemplate:
        fileserverEndpoint +
        "/public/excelTemplates/jy_importMmsVariantMaps.xlsx",
      // 导入
      importProductDF: false,
      url: "",
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
      importResults: [],
      // 新增换料映射
      addVariantMapsType: "whole",
      addVariantMapColors: [],
      validBoms: [],
      addVariantMapDF: false,
      addVariantMapObj: {
        selectedColors: [],
        needMapMaterials: [],
        needMapMaterialsFilter: [],
        variantMaps: [],
      },
      addVariantMapSubmitDoing: false,
      querySearchAddVariantMapLoading: false,
      importLoading: false,

      isIndeterminateColors: false,
      checkAllColors: false,
      //  编辑物料映射
      materials: [],
      serialNosLoading: false,
      currentColorVariantMap: [],
      editVariantMapDF: false,
      editVariantMapObj: {
        replaceMaterialId: null,
      },
      editVariantMapDoing: false,
      //
      loadingMaterial: false,
      //
      validateSerialNo: validateSerialNo,
      addIngredientAndMaterialDF: false,
      subjects: [],
      colors: [],
      addIngredientAndMaterialObj: {
        image: null,
        serialNo: null,
        name: null,
        subjectId: null,
        inUnit: null,
        unit: null,
        exchange: null,
        color: null,
        colorNo: null,
        supplierId: null,
        price: null,
        remark: null,
        baseQuantity: null,
        sizeQuantities: [],
        _sizesQuantityDF: false,
      },
      addIngredientAndMaterialDoing: false,
      materialSuppliers: [],
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    Product.findByUuid({ uuid: self.uuid }).then(function (res) {
      if (res.data.code === 200) {
        self.product = res.data.entity;
        self.url =
          coreMmsEndpoint + "/excels/variant-maps/import/" + self.product.id;
        self.getBoms();
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    getMaterialSuppliers(row) {
      const self = this;
      Material.findById(row.materialId).then(function (res) {
        if (res.data.code === 200) {
          self.materialSuppliers = res.data.entity.materialSuppliers;
        } else {
          self.sysError();
        }
      });
    },
    addIngredientAndMaterial() {
      const self = this;
      self.addIngredientAndMaterialObj.image = null;
      self.addIngredientAndMaterialObj.serialNo = null;
      self.addIngredientAndMaterialObj.name = null;
      self.addIngredientAndMaterialObj.subjectId = null;
      self.addIngredientAndMaterialObj.inUnit = null;
      self.addIngredientAndMaterialObj.unit = null;
      self.addIngredientAndMaterialObj.exchange = null;
      self.addIngredientAndMaterialObj.color = null;
      self.addIngredientAndMaterialObj.colorNo = null;
      self.addIngredientAndMaterialObj.supplierId = null;
      self.addIngredientAndMaterialObj.price = null;
      self.addIngredientAndMaterialObj.remark = null;
      self.addIngredientAndMaterialObj.baseQuantity = null;
      self.addIngredientAndMaterialObj.sizeQuantities = self.product.sizes.map(
        (s) => {
          return { size: s, quantity: null };
        }
      );
      self.getSubjects();
      self.getColors();
      self.addIngredientAndMaterialDF = true;
      self.addIngredientAndMaterialDoing = false;
    },
    getSubjects() {
      const self = this;
      SubjectMms.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.subjects = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getColors() {
      const self = this;
      Color.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.colors = res.data;
        } else {
          self.sysError();
        }
      });
    },
    showSizesQuantityAddIngredientAndMaterial() {
      const self = this;
      self.addIngredientAndMaterialObj._sizesQuantityDF =
        !self.addIngredientAndMaterialObj._sizesQuantityDF;
    },
    // 品名
    querySearchNames(queryString, cb) {
      Material.getNames().then(function (res) {
        const names = res.data.map((item) => {
          return { value: item };
        });
        cb(names);
      });
    },
    handleSelectNames(item) {
      this.addIngredientAndMaterialObj.name = item.value;
    },
    // 单位
    querySearchInUnits(queryString, cb) {
      Material.getInUnits().then(function (res) {
        const units = res.data.map((item) => {
          return { value: item };
        });
        cb(units);
      });
    },
    handleSelectInUnits(item) {
      this.addIngredientAndMaterialObj.inUnit = item.value;
    },
    // 单位
    querySearchUnits(queryString, cb) {
      Material.getUnits().then(function (res) {
        const units = res.data.map((item) => {
          return { value: item };
        });
        cb(units);
      });
    },
    handleSelectUnits(item) {
      this.addIngredientAndMaterialObj.unit = item.value;
    },
    // 颜色
    querySearchColors(queryString, cb) {
      const self = this;
      const colors = self.colors.map((item) => {
        return { value: item.name };
      });
      cb(colors);
    },
    handleSelectColors(item) {
      this.addIngredientAndMaterialObj.color = item.value;
    },
    addIngredientAndMaterialSubmit() {
      const self = this;
      self.$refs.addIngredientAndMaterialObjForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.addIngredientAndMaterialObj.baseQuantity)
          ) {
            this.$message({
              message: self.$t("rules.regex", [
                self.$t("material.baseQuantity"),
              ]),
              type: "warning",
            });
            return;
          }
          const sizeQuantities =
            self.addIngredientAndMaterialObj.sizeQuantities.filter(function (
              s
            ) {
              return s.quantity != null && s.quantity !== "";
            });
          if (sizeQuantities.length != 0) {
            for (const sizeQuantity of sizeQuantities) {
              if (!Util.regexQuantity(sizeQuantity.quantity)) {
                this.$message({
                  message: self.$t("rules.regex", [
                    self.$t("material.sizeQuantity"),
                  ]),
                  type: "warning",
                });
                return;
              }
            }
          }
          const obj = {
            baseQuantity: self.addIngredientAndMaterialObj.baseQuantity,
            material: {
              serialNo: self.addIngredientAndMaterialObj.serialNo,
              name: self.addIngredientAndMaterialObj.name,
              subjectId: self.addIngredientAndMaterialObj.subjectId,
              subjectName: self.subjects.find(
                (s) => s.id == self.addIngredientAndMaterialObj.subjectId
              ).name,
              inUnit: self.addIngredientAndMaterialObj.inUnit,
              unit: self.addIngredientAndMaterialObj.unit,
              exchange: self.addIngredientAndMaterialObj.exchange,
              color: self.addIngredientAndMaterialObj.color,
              colorNo: self.addIngredientAndMaterialObj.colorNo,
            },
            sizeQuantities: sizeQuantities,
            remark: self.addIngredientAndMaterialObj.remark,
          };
          self.addIngredientAndMaterialDoing = true;
          Product.addNoMaterialBom(self.product.id, obj).then(function (res) {
            self.addIngredientAndMaterialDoing = false;
            if (res.status === 200) {
              self.sysResult(res.data);
              if (res.data.type == "success") {
                self.getBoms();
                if (!["mixed", "mixing"].includes(self.product.mixState)) {
                  self.mix();
                }
                self.addIngredientAndMaterialDF = false;
              }
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //=========
    // 删除物料映射
    deleteVariantMap(d) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Bom.deleteVariantMaps(self.product.id, [d.id]).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getVariantMaps(self.boms);
          } else {
            self.sysError();
          }
        });
      }
    },
    //  编辑物料映射
    editVariantMap(data, colorData) {
      const self = this;
      self.row = data;
      self.currentColorVariantMap = colorData;
      self.editVariantMapDF = true;
      self.editVariantMapObj.replaceMaterialId = null;
      self.editVariantMapDoing = false;
    },
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.serialNosLoading = true;
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          for (const m of self.materials) {
            m.text = m.serialNo + "(" + m.name + ")";
          }
          self.serialNosLoading = false;
        }
      );
    },
    handleSelectSerialNoEditVariantMap() {
      const self = this;
      const tempItem = self.materials.find(
        (p) => p.id === self.editVariantMapObj.replaceMaterialId
      );
      let item = null;
      if (tempItem.parentMaterial != null) {
        item = tempItem.parentMaterial;
      } else {
        item = tempItem;
      }
      self.editVariantMapObj.replaceMaterialId = item.id;

      const replaceMaterialIds = self.currentColorVariantMap.map(
        (cv) => cv.replaceMaterialId
      );
      if (
        replaceMaterialIds.includes(self.editVariantMapObj.replaceMaterialId)
      ) {
        self.editVariantMapObj.replaceMaterialId = null;
        self.$message({
          message: self.$t("prompt.colorExistVariantMap"),
          type: "warning",
        });
      }
    },
    editVariantMapSubmit() {
      const self = this;
      self.$refs.editVariantMapObjForm.validate((valid) => {
        if (valid) {
          self.editVariantMapDoing = true;
          Bom.editVariantMaps(
            self.product.id,
            self.row.id,
            self.editVariantMapObj
          ).then(function (res) {
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.editVariantMapDoing = false;
              self.editVariantMapDF = false;
              self.getVariantMaps(self.boms);
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    printPriductMaterial(type) {
      this.printFunction(type);
    },
    // 配料完成
    ingredientFinish() {
      const self = this;
      Product.finishMix(self.product.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.ingredientFinishSucess"),
            type: "success",
          });
          self.$emit("updateInfo", "mixed");
        } else {
          self.sysError();
        }
      });
    },
    //新增映射
    addVariantMap() {
      const self = this;
      self.addVariantMapsType = "whole";
      const variantMapColors = self.variantMaps.map((v) => v.color);
      self.addVariantMapColors = self.product.colors.filter(
        (c) => !variantMapColors.includes(c)
      );
      if (self.addVariantMapColors.length === 0) {
        self.$message({
          message: self.$t("prompt.noVariantMapColors"),
          type: "warning",
        });
        return;
      }
      self.validBoms = self.boms.filter((b) => b.material.deleteAt == null);
      for (const bom of self.validBoms) {
        Vue.set(
          bom,
          "serialNoName",
          bom.material.serialNo + "(" + bom.material.name + ")"
        );
      }
      self.addVariantMapObj.selectedColors = [];
      self.addVariantMapObj.needMapMaterials = [
        JSON.parse(JSON.stringify(bulidVariantMap())),
        JSON.parse(JSON.stringify(bulidVariantMap())),
        JSON.parse(JSON.stringify(bulidVariantMap())),
      ];
      self.addVariantMapObj.variantMaps = [];
      self.addVariantMapSubmitDoing = false;
      self.addVariantMapDF = true;
    },
    //新增物料映射 根据颜色
    addVariantMapsByColor(gvm) {
      const self = this;
      self.addVariantMapsType = "byColor";
      self.addVariantMapColors = [gvm.color];
      const productMaterials = self.boms.filter(
        (b) => b.material.deleteAt == null
      );
      const currentColorVMBomIds = gvm.data.map((d) => d.bomId);
      self.validBoms = productMaterials.filter(
        (pm) => !currentColorVMBomIds.includes(pm.id)
      );
      self.validBoms.forEach(
        (pm) =>
          (pm.serialNoName =
            pm.material.serialNo + "(" + pm.material.name + ")")
      );
      self.addVariantMapObj.selectedColors = [gvm.color];
      self.addVariantMapObj.needMapMaterials = [
        JSON.parse(JSON.stringify(bulidVariantMap())),
        JSON.parse(JSON.stringify(bulidVariantMap())),
        JSON.parse(JSON.stringify(bulidVariantMap())),
      ];
      self.addVariantMapDF = true;
    },
    selectNeedMapMaterial(idx) {
      const self = this;
      const item = self.validBoms.find(
        (p) => p.id === self.addVariantMapObj.needMapMaterials[idx].bomId
      );
      // 前台本地过滤
      const iis = self.addVariantMapObj.needMapMaterials.filter(function (ii) {
        return ii.bomId === self.addVariantMapObj.needMapMaterials[idx].bomId;
      });
      if (iis.length > 1) {
        self.$message({
          message: self.$t("rules.exist", [self.$t("product.material")]),
          type: "warning",
        });
        self.addVariantMapObj.needMapMaterials[idx].bomId = null;
        return;
      }
      self.addVariantMapObj.needMapMaterials[idx]._material = item.material;
      self.addVariantMapObjVariantMapsCom();
    },
    removeNeedMapMaterial(idx) {
      this.addVariantMapObj.needMapMaterials.splice(idx, 1);
      this.addVariantMapObjVariantMapsCom();
    },
    addMoreNeedMapMaterial() {
      this.addVariantMapObj.needMapMaterials.push(
        JSON.parse(JSON.stringify(bulidVariantMap()))
      );
      this.addVariantMapObjVariantMapsCom();
    },
    handleCheckAllColorsChange(val) {
      this.addVariantMapObj.selectedColors = val
        ? this.addVariantMapColors
        : [];
      this.addVariantMapObjVariantMapsCom();
    },
    handleCheckedColorsChange(value) {
      const checkedCount = value.length;
      this.checkAllColors = checkedCount === this.addVariantMapColors.length;
      this.isIndeterminateColors =
        checkedCount > 0 && checkedCount < this.addVariantMapColors.length;
      this.addVariantMapObjVariantMapsCom();
    },
    addVariantMapObjVariantMapsCom() {
      this.addVariantMapObj.needMapMaterialsFilter =
        this.addVariantMapObj.needMapMaterials.filter((m) => m.bomId != null);
      if (
        this.addVariantMapObj.selectedColors.length != 0 &&
        this.addVariantMapObj.needMapMaterialsFilter.length != 0
      ) {
        const arr = this.addVariantMapObj.selectedColors.map((color) => {
          return {
            color: color,
            data: JSON.parse(
              JSON.stringify(this.addVariantMapObj.needMapMaterialsFilter)
            ),
          };
        });
        this.addVariantMapObj.variantMaps = arr;
      } else {
        this.addVariantMapObj.variantMaps = [];
      }
    },
    querySearchAddVariantMap(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.querySearchAddVariantMapLoading = true;
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          if (self.materials.length != 0) {
            for (const m of self.materials) {
              Vue.set(m, "serialNoName", m.serialNo + "(" + m.name + ")");
            }
          }
          self.querySearchAddVariantMapLoading = false;
        }
      );
    },
    handleSelectAddVariantMap(itemIndex, idx) {
      const self = this;
      const tempItem = self.materials.find(
        (p) =>
          p.id ===
          self.addVariantMapObj.variantMaps[idx].data[itemIndex]
            .replaceMaterialId
      );
      let item = null;
      if (tempItem.parentMaterial != null) {
        item = tempItem.parentMaterial;
      } else {
        item = tempItem;
      }
      self.addVariantMapObj.variantMaps[idx].data[itemIndex].replaceMaterialId =
        item.id;
      // 前台本地过滤
      const iis = self.addVariantMapObj.variantMaps[idx].data.filter(function (
        ii
      ) {
        return (
          ii.replaceMaterialId ===
          self.addVariantMapObj.variantMaps[idx].data[itemIndex]
            .replaceMaterialId
        );
      });
      if (iis.length > 1) {
        self.$message({
          message: self.$t("prompt.colorHasMaped"),
          type: "warning",
        });
        self.addVariantMapObj.variantMaps[idx].data[
          itemIndex
        ].replaceMaterialId = null;
        return;
      }
    },
    addVariantMapSubmit() {
      const self = this;
      if (self.addVariantMapObj.selectedColors.length == 0) {
        self.$message({
          message: self.$t("prompt.noSelectMapColors"),
          type: "warning",
        });
        return;
      }
      if (self.addVariantMapObj.needMapMaterialsFilter.length == 0) {
        self.$message({
          message: self.$t("prompt.noSelectMapBoms"),
          type: "warning",
        });
        return;
      }
      let data = [];
      for (const variantMap of self.addVariantMapObj.variantMaps) {
        for (const d of variantMap.data) {
          data.push({
            bomId: d.bomId,
            color: variantMap.color,
            materialId: d._material.id,
            replaceMaterialId: d.replaceMaterialId || 0,
          });
        }
      }
      // console.log("=====", data);
      self.addVariantMapSubmitDoing = true;
      Bom.variantMapInsertBatch(self.product.id, data).then(function (res) {
        self.addVariantMapSubmitDoing = false;
        self.addVariantMapDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.getVariantMaps();
        } else {
          self.sysError();
        }
      });
    },
    // 导入换料映射
    importVariantMap() {
      this.importVariantMapDF = !this.importVariantMapDF;
      if (!this.importVariantMapDF) {
        this.importResults = [];
      }
    },
    beforeAvatarUpload(file) {
      this.importLoading = true;
      return true;
    },
    importResult(res, file) {
      const self = this;
      this.importLoading = false;
      self.importResults = res.results;
      const text = "成功导入" + res.successQuantity + "条记录";
      if (res.allQuantity === res.successQuantity) {
        self.$message({ message: text, type: "success" });
      } else {
        self.$message({ message: "查看详细", type: "warning" });
      }
      if (res.allQuantity != res.failQuantity) {
        self.getVariantMaps();
      }
    },
    // 下载换料映射
    downloadVariantMap() {
      const self = this;
      const bomIds = self.boms.map((b) => b.id);
      Bom.variantMapsExportExcel(bomIds).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 删除换料映射
    deleteVariantMapsByColor(data) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        const ids = data.map((d) => d.id);
        Bom.deleteVariantMaps(self.product.id, ids).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getVariantMaps(self.boms);
          } else {
            self.sysError();
          }
        });
      }
    },
    // 加载配物料
    querySearchProductNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.productsLoading = true;
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        self.products = res.data;
        self.productsLoading = false;
      });
    },
    handleSelectProductNo(idx) {
      const self = this;
      const item = self.products.find((p) => p.productNo === self.productNo);
      if (item != null) {
        Product.boms(item.id).then(function (res) {
          if (res.status === 200) {
            const selectedProductNoBoms = res.data;
            if (selectedProductNoBoms.length === 0) {
              self.$message({
                message: self.$t("prompt.productNoNoBomInfo"),
                type: "warning",
              });
              return;
            }
            //

            const selectedProductNoBomsFilter = selectedProductNoBoms.filter(
              (selectedProductNoBom) =>
                self.boms.find(
                  (b) => b.materialId === selectedProductNoBom.materialId
                ) == null
            );
            if (selectedProductNoBomsFilter.length === 0) {
              self.$message({
                message: self.$t("prompt.productNoNoBomHasExist"),
                type: "warning",
              });
              return;
            }

            const newAddProductPhases = selectedProductNoBomsFilter.map((p) => {
              return {
                productId: self.product.id,
                materialId: p.materialId,
                baseQuantity: p.baseQuantity,
                sizeQuantities: p.sizeQuantities,
                remark: p.remark,
              };
            });

            Product.ingredient({
              id: self.product.id,
              boms: newAddProductPhases,
            }).then(function (res) {
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.addSuccess"),
                  type: "success",
                });
                self.productNo = null;
                self.getBoms();
                if (!["mixed", "mixing"].includes(self.product.mixState)) {
                  self.mix();
                }
              } else {
                self.sysError();
              }
            });
          } else {
            self.sysError();
          }
        });
      }
    },
    // 下载配料
    downloadBoms(cmd) {
      const self = this;
      if (cmd == "download1") {
        Product.exportExcelBoms(self.product.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        });
      } else {
        Product.exportExcelForEditBoms(self.product.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        });
      }
    },
    //
    addIngredient() {
      const self = this;
      const newBulidIngredient = bulidIngredient();
      newBulidIngredient._sizeQuantities = self.product.sizes.map((s) => {
        return { size: s, quantity: null };
      });
      self.addIngredientObj.items = [
        JSON.parse(JSON.stringify(newBulidIngredient)),
        JSON.parse(JSON.stringify(newBulidIngredient)),
        JSON.parse(JSON.stringify(newBulidIngredient)),
      ];
      self.addIngredientSubmitDoing = false;
      self.addIngredientDF = true;
    },
    querySearchMaterial(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.materialLoading = true;
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          if (self.materials.length !== 0) {
            for (const material of self.materials) {
              Vue.set(
                material,
                "serialNoName",
                material.serialNo + "(" + material.name + ")"
              );
            }
          }
          self.materialLoading = false;
        }
      );
    },
    handleSelectMaterial(idx) {
      const self = this;
      const tempItem = self.materials.find(
        (p) => p.id === self.addIngredientObj.items[idx].materialId
      );
      let item = null;
      if (tempItem.parentMaterial != null) {
        item = tempItem.parentMaterial;
      } else {
        item = tempItem;
      }
      self.addIngredientObj.items[idx].materialId = item.id;

      self.addIngredientObj.items[idx]._localRepeat = false;
      self.addIngredientObj.items[idx]._invExist = false;
      self.addIngredientObj.items[idx]._serialNo = item.serialNo;
      self.addIngredientObj.items[idx]._name = item.name;
      self.addIngredientObj.items[idx]._subjectName = item.subjectName;
      self.addIngredientObj.items[idx]._color = item.color;
      self.addIngredientObj.items[idx]._unit = item.unit;
      self.addIngredientObj.items[idx]._sizesQuantityRate = null;
      // 库存过滤
      if (
        self.boms.filter(
          (q) => q.materialId == self.addIngredientObj.items[idx].materialId
        ).length != 0
      ) {
        self.addIngredientObj.items[idx]._invExist = true;
        return;
      }
      // 本地过滤
      const iis = self.addIngredientObj.items.filter(
        (s) => s.materialId === item.id
      );
      if (iis.length > 1) {
        self.addIngredientObj.items[idx]._localRepeat = true;
        return;
      }
    },
    showSizesQuantity(idx) {
      this.addIngredientObj.items[idx]._sizesQuantityDF = true;
    },
    addMore() {
      const newBulidIngredient = bulidIngredient();
      newBulidIngredient._sizeQuantities = this.product.sizes.map((s) => {
        return { size: s, quantity: null };
      });
      this.addIngredientObj.items.push(
        JSON.parse(JSON.stringify(newBulidIngredient))
      );
    },
    removeIngredient(idx) {
      this.addIngredientObj.items.splice(idx, 1);
    },
    addMoreQuotation() {
      const self = this;
      const newBulidIngredient = bulidIngredient();
      newBulidIngredient._sizeQuantities = self.product.sizes.map((s) => {
        return { size: s, quantity: null };
      });
      self.addIngredientObj.items.push(newBulidIngredient);
    },
    addIngredientSubmit() {
      const self = this;
      const items = this.addIngredientObj.items.filter(function (item) {
        return item.materialId != null && item.baseQuantity != null;
      });
      if (items.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }
      const errDatas = items.filter(
        (s) => s._localRepeat === true || s._invExist === true
      );
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }
      for (const i of items) {
        if (!Util.regexQuantity(i.baseQuantity) && i.baseQuantity !== 0) {
          self.$message({
            message: self.$t("rules.regex", [self.$t("material.quantity")]),
            type: "warning",
          });
          return;
        }
        const sizeQuantities = i._sizeQuantities.filter(
          (p) => p.quantity != null && p.quantity !== ""
        );
        if (sizeQuantities.length !== 0) {
          for (const f of sizeQuantities) {
            if (!Util.regexPrice(f.quantity) && f.quantity !== 0) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("material.sizeQuantity"),
                ]),
                type: "warning",
              });
              return;
            }
          }
        }
        i.sizeQuantities = sizeQuantities;
        i.productId = self.product.id;
      }

      self.addIngredientSubmitDoing = true;
      Product.ingredient({ id: self.product.id, boms: items }).then(function (
        res
      ) {
        self.addIngredientSubmitDoing = false;
        self.addIngredientDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });

          self.getBoms();
          if (!["mixed", "mixing"].includes(self.product.mixState)) {
            self.mix();
          }
        } else {
          self.sysError();
        }
      });
    },
    mix() {
      const self = this;
      Product.mix(self.product.id).then(function (res) {
        if (res.status === 200) {
          self.product.mixState = "mixing";
        } else {
          self.sysError();
        }
      });
    },
    // 删除配料
    deleteBom(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Product.deleteBom(self.product.id, row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getBoms();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑配料
    editBom(row) {
      const self = this;
      self.row = row;
      self.editIngredientObj.bomId = self.row.id;
      self.editIngredientObj.baseQuantity = row.baseQuantity;
      self.editIngredientObj.remark = row.remark;
      self.editIngredientObj.sizeQuantities = [];
      if (self.product.sizes.length !== 0) {
        self.editIngredientObj.sizeQuantities = self.product.sizes.map((s) => {
          const sizeQuantityObj = self.row.sizeQuantities.find(
            (sq) => sq.size === s
          );
          return {
            bomId: self.row.id,
            size: s,
            quantity: sizeQuantityObj == null ? null : sizeQuantityObj.quantity,
          };
        });
      }
      self.editIngredientSubmitDoing = false;
      self.editIngredientDF = true;
    },
    editIngredientSubmit() {
      const self = this;
      self.$refs.editIngredientObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editIngredientObj.baseQuantity)) {
            this.$message({
              message: self.$t("rules.regex", [
                self.$t("material.baseQuantity"),
              ]),
              type: "warning",
            });
            return;
          }
          const sizeQuantities = self.editIngredientObj.sizeQuantities.filter(
            function (s) {
              return s.quantity != null && s.quantity !== "";
            }
          );
          if (sizeQuantities.length != 0) {
            for (const sizeQuantity of sizeQuantities) {
              if (!Util.regexQuantity(sizeQuantity.quantity)) {
                this.$message({
                  message: self.$t("rules.regex", [
                    self.$t("material.sizeQuantity"),
                  ]),
                  type: "warning",
                });
                return;
              }
            }
          }
          self.editIngredientObj.sizeQuantities = sizeQuantities;
          self.editIngredientSubmitDoing = true;
          Product.updateBom(
            self.product.id,
            self.row.id,
            self.editIngredientObj
          ).then(function (res) {
            self.editIngredientSubmitDoing = false;
            self.editIngredientDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getBoms();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 配料
    getBoms() {
      const self = this;
      self.loadingMaterial = true;
      Product.boms(self.product.id).then(function (res) {
        if (res.status === 200) {
          self.loadingMaterial = false;
          self.boms = res.data;
          self.computeMmsCost();
          self.buildTableData();
          self.getVariantMaps();
        } else {
          self.sysError();
        }
      });
    },
    getVariantMaps() {
      const self = this;
      if (self.boms.length === 0) {
        return;
      }
      const bomIds = self.boms.map((b) => b.id);
      Bom.variantMaps(bomIds).then(function (res) {
        if (res.status === 200) {
          self.variantMaps = res.data;
          self.groupVariantMap();
        } else {
          self.sysError();
        }
      });
    },
    groupVariantMap() {
      const self = this;
      self.groupVariantMaps = [];
      var map = {};
      for (var i = 0; i < self.variantMaps.length; i++) {
        var ai = self.variantMaps[i];
        if (!map[ai.color]) {
          self.groupVariantMaps.push({
            color: ai.color,
            data: [ai],
          });
          map[ai.color] = ai;
        } else {
          for (var j = 0; j < self.groupVariantMaps.length; j++) {
            var dj = self.groupVariantMaps[j];
            if (dj.color === ai.color) {
              dj.data.push(ai);
              break;
            }
          }
        }
      }
    },
    computeMmsCost() {
      const self = this;
      self.mmsCost = 0;
      if (self.boms.length === 0) {
        return;
      }
      for (const bom of self.boms) {
        if (bom.material != null) {
          self.mmsCost = self.mmsCost + bom.baseQuantity * bom.material.price;
        }
      }
    },
    buildTableData() {
      const self = this;
      self.groupBoms = [];
      if (self.boms.length === 0) {
        return;
      }
      const bomsNoMaterial = self.boms.filter((b) => b.material == null);
      const boms = self.boms.filter((b) => b.material != null);
      if (boms.length != 0) {
        const subjectIds = boms.map((b) => b.material.subjectId);
        const subjectIdsSet = [...new Set(subjectIds)];
        for (const subjectId of subjectIdsSet) {
          const currentSubjectBoms = self.boms.filter(
            (b) => b.material.subjectId == subjectId
          );
          // let currentSubjectBoms = [];
          // let i = 0;
          // for (let b of self.boms) {
          //   if (b.material.subjectId == subjectId) {
          //     let obj = b;
          //     obj.sequence = i + 1;
          //     currentSubjectBoms.push(obj);
          //   }
          // }
          // console.log("====currentSubjectBoms:", currentSubjectBoms);
          self.groupBoms.push({
            id: subjectId,
            subject: currentSubjectBoms[0].material.subjectName,
            isSubject: true,
            boms: currentSubjectBoms,
            subjectTotal: self.computeSubjectTotal(currentSubjectBoms),
          });
          for (const bomIndex in currentSubjectBoms) {
            let tempBom = currentSubjectBoms[bomIndex];
            tempBom.sequence = Number(bomIndex) + 1;
            self.groupBoms.push(tempBom);
          }
        }
      }
      if (bomsNoMaterial.length != 0) {
        self.groupBoms.push({
          id: -1,
          subject: " ",
          boms: bomsNoMaterial,
        });
        for (const bom of bomsNoMaterial) {
          self.groupBoms.push(bom);
        }
      }
    },

    computeSubjectTotal(currentSubjectBoms) {
      let total = 0;
      for (const b of currentSubjectBoms) {
        total = total + b.baseQuantity * b.material.price;
      }
      return total;
    },
    buildMergeCells() {
      let mcs = [];
      let colspanNum = 7;
      if (this.Permit.canActionsChargeEdition("mmsProductIngredient")) {
        colspanNum = colspanNum + 1;
      }
      if (this.Permit.canActionsChargeEdition("globalCostPrice")) {
        colspanNum = colspanNum + 2;
      }
      for (let i = 0, rowIdx = 0; i < this.groupBoms.length; i++) {
        mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: colspanNum });
        if (this.groupBoms[i].boms) {
          rowIdx = rowIdx + this.groupBoms[i].boms.length + 1;
        }
      }
      return mcs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.buildMergeCells();
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isSubject ? "light-blue-bg" : "";
    },
  },
};
</script>